import type { AuthGateway } from '../application/AuthGateway'
import { AuthFailure, type OperatorSession } from '../domain/session'

// Comptes de démonstration (mode fixtures : développement et tests seulement).
export const fixtureAccounts: Record<string, { password: string; session: OperatorSession }> = {
  'o.gauthier@groupereca.com': {
    password: 'terrain-demo',
    session: {
      userId: 'a0000000-0000-4000-a000-000000000001',
      email: 'o.gauthier@groupereca.com',
      displayName: 'Olivier Gauthier',
      status: 'ACTIVE',
      canOperate: true,
      employeeId: 'b0000000-0000-4000-a000-000000000001',
    },
  },
  'm.pelletier@groupereca.com': {
    password: 'terrain-demo',
    session: {
      userId: 'a0000000-0000-4000-a000-000000000002',
      email: 'm.pelletier@groupereca.com',
      displayName: 'Maude Pelletier',
      status: 'ACTIVE',
      canOperate: true,
      employeeId: 'b0000000-0000-4000-a000-000000000002',
    },
  },
  'n.temporaire@groupereca.com': {
    password: 'temporaire-demo',
    session: {
      userId: 'a0000000-0000-4000-a000-000000000003',
      email: 'n.temporaire@groupereca.com',
      displayName: 'Noé Temporaire',
      status: 'PASSWORD_CHANGE_REQUIRED',
      canOperate: true,
      employeeId: 'b0000000-0000-4000-a000-000000000003',
    },
  },
  'bureau@groupereca.com': {
    password: 'bureau-demo',
    session: {
      userId: 'a0000000-0000-4000-a000-000000000004',
      email: 'bureau@groupereca.com',
      displayName: 'Camille Bureau',
      status: 'ACTIVE',
      canOperate: false,
      employeeId: null,
    },
  },
}

const storageKey = 'reca-operator-v3-fixture-session'

export function createFixtureAuthGateway(): AuthGateway {
  const read = () => {
    try {
      return window.localStorage.getItem(storageKey)
    } catch {
      return null
    }
  }
  const write = (email: string | null) => {
    try {
      if (email) window.localStorage.setItem(storageKey, email)
      else window.localStorage.removeItem(storageKey)
    } catch {
      // stockage bloqué : la session ne survit pas au rechargement
    }
  }
  return {
    getSession() {
      const email = read()
      return Promise.resolve(email ? (fixtureAccounts[email]?.session ?? null) : null)
    },
    signIn(identifier, password) {
      const email = identifier.trim().toLowerCase()
      const account = fixtureAccounts[email]
      if (account?.password !== password) {
        return Promise.reject(new AuthFailure('INVALID_CREDENTIALS', 'Identifiant ou mot de passe invalide.'))
      }
      write(email)
      return Promise.resolve(account.session)
    },
    signOut() {
      write(null)
      return Promise.resolve()
    },
    replaceTemporaryPassword(currentPassword, newPassword) {
      const email = read()
      const account = email ? fixtureAccounts[email] : undefined
      if (!account) return Promise.reject(new AuthFailure('SESSION_EXPIRED', 'Reconnectez-vous.'))
      if (account.password !== currentPassword) {
        return Promise.reject(new AuthFailure('UNEXPECTED', 'Le mot de passe temporaire saisi est incorrect.'))
      }
      account.password = newPassword
      account.session = { ...account.session, status: 'ACTIVE' }
      return Promise.resolve(account.session)
    },
  }
}
